export class Region {
    region : number;
    states : string;
    
}


// WEBPACK FOOTER //
// ./src/app/model/region.model.ts